import { CSSProperties } from 'styled-components';
import { Breakpoint } from 'antd/lib/_util/responsiveObserve';

export type BannerJSONText = string | JSX.Element;
// | {
//     [breakpoint in string]: string;
//   };

export type BannerJSONUrl = {
  url?: string;
  href?: string;
  isNewTab?: boolean;
  isTnc?: boolean;
};

export type BannerJSONStyle =
  | {
      default: CSSProperties;
    }
  | {
      [breakpoint in Breakpoint]: CSSProperties;
    };

export type BannerJsonModal = {
  id?: string;
  title?: string | JSX.Element | null;
  image?: string;
  detail?: string | JSX.Element | null;
  style?: BannerJSONStyle;
};

export type BannerJSONButtonProps = {
  text?: BannerJSONText;
  style?: BannerJSONStyle;
  url?: string;
  href?: string;
  isNewTab?: boolean;
  isTnc?: boolean;
  modal?: BannerJsonModal | null;
};

export type BannerJSONButton = {
  buttons?: BannerJSONButtonProps[];
  style?: BannerJSONStyle;
};

export type BannerJSONCounterProps = {
  background_url: string;
  end_time?: string;
  style?: BannerJSONStyle;
};

export type BannerJSONContent = {
  title?: BannerJSONButtonProps;
  desc?: BannerJSONButtonProps;
  button?: BannerJSONButton;
  wrapperStyle?: BannerJSONStyle;
  counter?: BannerJSONCounterProps;
};

export type BannerJSON = {
  order?: number;
  images: {
    [breakpoint in string]: string;
  };
  contents?: {
    content: BannerJSONContent;
    wrapperStyle?: BannerJSONStyle;
  }[];
  url?: string;
  href?: string;
  isNewTab?: boolean;
  isTnc?: boolean;
  modal?: BannerJsonModal | null;
  isListingPage?: boolean;
  listingImages?: any;
  isInternalLink?: boolean;
};

export type BannersJSON = BannerJSON[];

// eslint-disable-next-line no-shadow
export enum ListingPromoComponentType {
  Single = 'homepage-promotions.single',
  Double = 'homepage-promotions.double',
}

export interface ListingPromoSingleCard {
  __component: ListingPromoComponentType.Single;
  background_color?: string;
  images: { [breakpoint in Breakpoint]: { url: string } } & {
    ctaUrl: string;
    isOpenUrlToNewTab: boolean;
  };
  contents: {
    [breakpoint in Breakpoint]: string;
  };
  cta: {
    label: string;
    url: string;
    styles: {
      fontSize: string;
    };
    position: {
      top: string;
      left: string;
      bottom: string;
      right: string;
    };
  };
}

export interface ListingPromoDoubleCard {
  __component: ListingPromoComponentType.Double;
  top_images: { [breakpoint in Breakpoint]: { url: string } } & {
    ctaUrl: string;
    isOpenUrlToNewTab: boolean;
  };
  bottom_images: { [breakpoint in Breakpoint]: { url: string } } & {
    ctaUrl: string;
    isOpenUrlToNewTab: boolean;
  };
}

export interface ListingPromoCard {
  id: number;
  locale: string;
  isFirstPromo: boolean;
  promoOrder: number;
  values?: (ListingPromoSingleCard | ListingPromoDoubleCard)[];
}
